import { IconBase, IconComponent } from './BaseIcon';

export const Embroidery: IconComponent = (props) => (
  <IconBase {...props}>
    <path id="e1" d="M2 12.2 19.8 30a1.6 1.6 0 1 0 1.2-1.2L3.2 11A1.6 1.6 0 1 0 2 12.2Z" />
    <use href="#e1" x="4.5" y="-4.5" />
    <use href="#e1" x="9" y="-9" />
    <use id="e2" href="#e1" transform="rotate(90 16 16)" />
    <use href="#e2" x="4.5" y="4.5" />
    <use href="#e2" x="9" y="9" />
  </IconBase>
);
